export default "__VITE_ASSET__Aagd9UOb__"